import { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../../../services/DefaultService';
import { AppContext } from 'context/AppContextProvider';

const Logout = () => {
  const { showSnackbar, setIsOpenedSidebar } = useContext(AppContext);

  const navigate = useNavigate();

  useEffect(() => {
    sessionStorage.removeItem('token');
    api.defaults.headers.common.Authorization = undefined;

    setIsOpenedSidebar(false);
    navigate('/app/authentication/sign-in', { replace: true });
    showSnackbar('Desconectado!', 'info');
  }, [navigate]);

  return null;
};

export default Logout;
